import {booleanAttribute, ChangeDetectionStrategy, Component, computed, Injectable, input} from "@angular/core";
import {DokumentId, DokumentSignatarerModell, DokumentSignatarModell, SigneringStatus} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {DokumentSigneringInformasjon} from "felles-ng2/tjenester/DokumentSigneringInformasjon";
import {ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {MedlemListevisningKompaktKomponent} from "../../../medlem/komponenter/medlem-listevisning-kompakt/medlem-listevisning-kompakt";
import {signatarerSomHarSignert, signatarerSomIkkeHarSignert} from "felles-ng2/modell/dokumentSignatarerModellHjelpere";
import {SigneringSendPåminnelseDialogKomponent} from "web-ng2/moduler/signering/modale/signering-send-påminnelse-dialog/signering-send-påminnelse-dialog";
import {MatDialog} from "@angular/material/dialog";
import {FormaterZonedDateTimePipe} from "felles-ng2/pipes/FormaterZonedDateTimePipe";
import {MatIcon} from "@angular/material/icon";
import {C3TodeltPaiKomponent} from "web-ng2/delt/komponenter/c3-todelt-pai/c3-todelt-pai";
import {pieKonfigBlaa, pieKonfigGroenn} from "web-ng2/moduler/signering/komponenter/signering-status/signeringStatusPieHjelpere";

const debug = initDebugger('SigneringStatusKomponent');

/**
 * Lister signatarer og dere signeringsstatus
 */
@Component({
    selector: 'signering-status',
    templateUrl: 'signering-status.html',
    styleUrl: 'signering-status.scss',
    host: {'data-testid': 'signering-status'},
    imports: [
        ReactiveFormsModule,
        TranslateModule,
        MedlemListevisningKompaktKomponent,
        FormaterZonedDateTimePipe,
        MatIcon,
        C3TodeltPaiKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SigneringStatusKomponent {

    signatarer = input.required<DokumentSignatarerModell>();
    status = input<SigneringStatus>();
    visSendPaaminnelse = input(true, {transform: booleanAttribute});

    harSignert = computed(() => signatarerSomHarSignert(this.signatarer()))
    harIkkeSignert = computed(() => signatarerSomIkkeHarSignert(this.signatarer()))
    statuser = SigneringStatus;
    pieKonfigBlaa = pieKonfigBlaa;
    pieKonfigGroenn = pieKonfigGroenn;

    constructor(private avhengigheter: SigneringStatusKomponentAvhengigheter, private signeringInformasjon: DokumentSigneringInformasjon) {
    }

    signeringsinformasjon(signatar: DokumentSignatarModell) {
        return this.signeringInformasjon.signaturinformasjonSomTekst(signatar.signaturinformasjon!);
    }

    sendPaaminnelse() {
        this.avhengigheter.sendPåminnelse(this.signatarer().dokumentId);
    }
}

@Injectable()
export class SigneringStatusKomponentAvhengigheter {

    constructor(private matDialog: MatDialog) {
    }

    sendPåminnelse(dokumentId: DokumentId): void {
        SigneringSendPåminnelseDialogKomponent.vis(this.matDialog, dokumentId);
    }
}
